/** Display format for date-only pickers (e.g. "Feb 17 2026") */
export const DATE_PICKER_FORMAT = "MMM D, YYYY";
